module.exports = __webpack_public_path__ + "static/media/pptx.51c13934.svg";